var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUvFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 Z",
    id: "path-1-filter"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFP-Imagery",
    transform: "translate(-363.000000, -252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/36px/UV-Filter",
    transform: "translate(365.000000, 254.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1-filter"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.03,
    fill: "#27CAE3",
    xlinkHref: "#path-1-filter"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    d: "M18,37 C7.50658975,37 -1,28.4934102 -1,18 C-1,7.50658975 7.50658975,-1 18,-1 C28.4934102,-1 37,7.50658975 37,18 C37,28.4934102 28.4934102,37 18,37 Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.04,
    stroke: "#00ADC6",
    strokeWidth: 1,
    d: "M18,35.5 C27.6649831,35.5 35.5,27.6649831 35.5,18 C35.5,8.33501688 27.6649831,0.5 18,0.5 C8.33501688,0.5 0.5,8.33501688 0.5,18 C0.5,27.6649831 8.33501688,35.5 18,35.5 Z",
    strokeLinejoin: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25,18 L24,18 C23.447,18 23,17.552 23,17 C23,16.448 23.447,16 24,16 L25,16 C25.553,16 26,16.448 26,17 C26,17.552 25.553,18 25,18 Z M23.705,22.705 C23.311,23.099 22.672,23.099 22.278,22.705 L21.565,21.992 C21.172,21.598 21.172,20.959 21.565,20.565 C21.959,20.171 22.598,20.171 22.991,20.565 L23.705,21.278 C24.099,21.672 24.099,22.311 23.705,22.705 Z M18,21 C16.896,21 15.896,20.552 15.172,19.829 C14.447,19.104 14,18.104 14,17 C14,15.896 14.447,14.896 15.172,14.171 C15.896,13.448 16.896,13 18,13 C19.104,13 20.104,13.448 20.828,14.171 C21.553,14.896 22,15.896 22,17 C22,18.104 21.553,19.104 20.828,19.829 C20.104,20.552 19.104,21 18,21 Z M19,24 C19,24.552 18.553,25 18,25 C17.447,25 17,24.552 17,24 L17,23 C17,22.448 17.447,22 18,22 C18.553,22 19,22.448 19,23 L19,24 Z M14.435,21.992 L13.722,22.705 C13.328,23.099 12.689,23.099 12.295,22.705 C11.901,22.311 11.901,21.672 12.295,21.278 L13.008,20.565 C13.402,20.172 14.041,20.172 14.435,20.565 C14.828,20.959 14.828,21.598 14.435,21.992 Z M11,18 C10.447,18 10,17.552 10,17 C10,16.448 10.447,16 11,16 L12,16 C12.553,16 13,16.448 13,17 C13,17.552 12.553,18 12,18 L11,18 Z M12.295,11.295 C12.689,10.901 13.328,10.901 13.722,11.295 L14.435,12.008 C14.828,12.402 14.828,13.041 14.435,13.435 C14.041,13.829 13.402,13.829 13.009,13.435 L12.295,12.722 C11.901,12.328 11.901,11.689 12.295,11.295 Z M17,10 C17,9.448 17.447,9 18,9 C18.553,9 19,9.448 19,10 L19,11 C19,11.552 18.553,12 18,12 C17.447,12 17,11.552 17,11 L17,10 Z M21.565,12.008 L22.278,11.295 C22.672,10.901 23.311,10.901 23.705,11.295 C24.099,11.689 24.099,12.328 23.705,12.722 L22.991,13.435 C22.598,13.829 21.959,13.829 21.565,13.435 C21.172,13.041 21.172,12.402 21.565,12.008 Z M23,6 L20,5 L18,4 L16,5 L13,6 L7,7 L7,20 C7,22.64 8.564,24.125 12.007,26.998 L18,32 L23.996,26.996 C27.527,24.049 29,22.593 29,20 L29,7 L23,6 Z",
    id: "Fill-1",
    fillOpacity: 0.65,
    fill: "#27CAE3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUvFilter);
export default __webpack_public_path__ + "static/media/UVFilter.3ef324685439fc17b429297bdc2556d0.svg";
export { ForwardRef as ReactComponent };